import { Modal, Empty } from "antd";
import { Flex } from "@chakra-ui/react";
import OutlineButton from "ui/components/Button/OutlineButton";
import Historico from "./components/Historico";
import { useLoading } from "ui/components/GlobalLoading/index";
import useHistoricoEmail from "core/features/relatorios/hooks/useHistoricoEmail";

interface ModalHistoricoProps {
  isOpenModal: boolean;
  onClose: () => any;
  id: string | undefined;
}

export default function ModalHistoricoEmail({
  id,
  isOpenModal,
  onClose,
}: ModalHistoricoProps) {
  const { data, isFetching } = useHistoricoEmail(id);

  useLoading(isFetching);

  return (
    <Modal
      visible={isOpenModal}
      onCancel={onClose}
      centered
      footer={
        <Flex flex={1} justifyContent="end">
          <OutlineButton onClick={onClose}>Fechar</OutlineButton>
        </Flex>
      }
    >
      <Historico logs={data ?? []} />
      {!data?.length && !isFetching ? (
        <Empty description="Sem dados de histórico para essa unidade" />
      ) : null}
    </Modal>
  );
}
